import http from "@/api";

function smthNamedPrefix(named, prefix){
    return named.toLowerCase() + prefix[0].toUpperCase() + prefix.substring(1)
}
function smthMutate(prefix, named){
    return prefix + named.toUpperCase();
}

function stateNamed(named){
    return {
        [smthNamedPrefix(named, "ApiRoute")]: "/api",
        [smthNamedPrefix(named, "UseApiGroup")]: true,
        [smthNamedPrefix(named, "UniqueServerSided")]: false,
        [smthNamedPrefix(named, "endpoint")]: undefined,
        [smthNamedPrefix(named, "endpoints")]: {},
        [smthNamedPrefix(named, "current")]: {},
        [smthNamedPrefix(named, "list")]: [],
        [smthNamedPrefix(named, "api")]: [],
        [smthNamedPrefix(named, "payload")]: [],
    };
}

function mutationsNamed(named){
    return {
        [smthMutate("SET_CURRENT_", named)](state, current){
            state[smthNamedPrefix(named, "current")] = current;
        },
        [smthMutate("SET_LIST_", named)](state, {list, payload}){
            if(list.results){
                state[smthNamedPrefix(named, "list")] = list.results;
                delete list.results;
                state[[smthNamedPrefix(named, "api")]] = list;
            }else{
                state[smthNamedPrefix(named, "list")] = list;
            }
            state[[smthNamedPrefix(named, "payload")]] = payload;
        },
        [smthMutate("SET_LIST_DIRECT_", named)](state, list){
            state[smthNamedPrefix(named, "list")] = list;
        },
    };
}

function gettersNamed(named){
    return {
        [smthNamedPrefix(named, "HTTP")]: () => { return http; },
        //[smthNamedPrefix(named, "apiUrlNamed")]: (state, getters, rootState, rootGetters) => (url) => {
        //    var base = state[smthNamedPrefix(named, "UseApiGroup")] ?
        //        rootGetters['Groupv2/APIGroup'] : state[smthNamedPrefix(named, "ApiRoute")];
        //    return base+state[smthNamedPrefix(named, "endpoints")][url];
        //},
        //[smthNamedPrefix(named, "apiUrl")]: (state, getters, rootState, rootGetters) => {
        //    var base = state[smthNamedPrefix(named, "UseApiGroup")] ?
        //        rootGetters['Groupv2/APIGroup'] : state[smthNamedPrefix(named, "ApiRoute")];
        //    return base+state[smthNamedPrefix(named, "endpoint")];
        //},
        [smthNamedPrefix(named, "apiUrlNamed")]: (state, getters, rootState, rootGetters) => (url) => {
            var base = state[smthNamedPrefix(named, "UseApiGroup")] ?
                rootGetters['User/apiGroup'] : state[smthNamedPrefix(named, "ApiRoute")];
            return base+state[smthNamedPrefix(named, "endpoints")][url];
        },
        [smthNamedPrefix(named, "apiUrl")]: (state, getters, rootState, rootGetters) => {
            var base = state[smthNamedPrefix(named, "UseApiGroup")] ?
                rootGetters['User/apiGroup'] : state[smthNamedPrefix(named, "ApiRoute")];
            return base+state[smthNamedPrefix(named, "endpoint")];
        },
        [smthNamedPrefix(named, "apiUrlDetail")]: (state, getters) => (url) => {
            return getters[smthNamedPrefix(named, "apiUrlNamed")](url);
        },
        [smthNamedPrefix(named, "apiUrlList")]: (state, getters) => (url) => {
            return getters[smthNamedPrefix(named, "apiUrlNamed")](url);
        },
        [smthNamedPrefix(named, "apiUrlUpdate")]: (state, getters) => (url) => {
            return getters[smthNamedPrefix(named, "apiUrlNamed")](url);
        },
        [smthNamedPrefix(named, "apiUrlCreate")]: (state, getters) => (url) => {
            return getters[smthNamedPrefix(named, "apiUrlNamed")](url);
        },
        [smthNamedPrefix(named, "apiUrlDelete")]: (state, getters) => (url) => {
            return getters[smthNamedPrefix(named, "apiUrlNamed")](url);
        },
        [smthNamedPrefix(named, "ByNamedId")]: (state) => (named_id) => {
            return state[smthNamedPrefix(named, "List")].find(x => x.named_id == named_id);
        },
        [smthNamedPrefix(named, "ByUid")]: (state) => (uid) => {
            return state[smthNamedPrefix(named, "List")].find(x => x.uid == uid);
        },
        [smthNamedPrefix(named, "By")]: (state) => (field, value) => {
            return state[smthNamedPrefix(named, "List")].find(x => x[field] == value);
        },

    };
}

function actionsNamed(named){
    return {
        [smthNamedPrefix(named, "setCurrent")]({ commit }, data) {
            const cmt = smthMutate("SET_CURRENT_", named);
            commit(cmt, data);
        },
        async [smthNamedPrefix(named, "getDetail")]({ state, getters }, uid) {
            const url = getters[smthNamedPrefix(named, "apiUrlDetail")](named);
            if(state[smthNamedPrefix(named, "UniqueServerSided")])
                return await http.get(url);
            return await http.get(url + uid + "/");
        },
        async [smthNamedPrefix(named, "setDetail")]({ dispatch, commit }, uid) {
            const act = smthNamedPrefix(named, "getDetail");
            const cmt = smthMutate("SET_CURRENT_", named);
            const response = await dispatch(act, uid);
            commit(cmt, response.data);
            return response;
        },
        async [smthNamedPrefix(named, "EraseDetail")]({ commit }) {
            const cmt = smthMutate("SET_CURRENT_", named);
            commit(cmt, {});
        },
        async [smthNamedPrefix(named, "getList")]({ getters }, payload) {
            const url = getters[smthNamedPrefix(named, "apiUrlList")](named);
            const response = await http.get(url, payload);
            return response;
        },
        async [smthNamedPrefix(named, "setList")]({ dispatch, commit }, payload) {
            const act = smthNamedPrefix(named, "getList");
            const cmt = smthMutate("SET_LIST_", named);
            const response = await dispatch(act, payload);
            commit(cmt, {list: response.data, payload: payload.params});
            return response;
        },
        async [smthNamedPrefix(named, "Create")]({ getters, commit }, { payload, config }) {
            const url = getters[smthNamedPrefix(named, "apiUrlCreate")](named);
            const cmt = smthMutate("SET_CURRENT_", named);
            const response = await http.post(url, payload, config);
            commit(cmt, response.data);
            return response;
        },
        async [smthNamedPrefix(named, "Update")]({ getters, commit }, {uid, payload, config}) {
            const url = getters[smthNamedPrefix(named, "apiUrlUpdate")](named);
            const cmt = smthMutate("SET_CURRENT_", named);
            const response = await http.put(url + uid + "/", payload, config);
            commit(cmt, response.data);
            return response;
        },
        async [smthNamedPrefix(named, "Delete")]({ getters, commit }, uid) {
            const url = getters[smthNamedPrefix(named, "apiUrlDelete")](named);
            const cmt = smthMutate("SET_CURRENT_", named);
            const response = await http.delete(url + uid + "/");
            commit(cmt, {});
            return response;
        },
        async [smthNamedPrefix(named, "EraseList")]({ commit }) {
            const cmt = smthMutate("SET_LIST_", named);
            commit(cmt, []);
        },
    };
}

export default function setupStoreBackend(name, store) {
    return {
        state: stateNamed(name, store),
        mutations: mutationsNamed(name, store),
        getters: gettersNamed(name, store),
        actions: actionsNamed(name, store),
    }
}
